import React from 'react';
import classnames from 'classnames';
import Slider from 'react-slick';
import { Picture } from 'components/UI';
import {
  iconLeftArrow,
  iconRightArrow,
  imgReviewAyudita,
  imgReviewJeff,
  imgReviewStephen,
  imgReviewJustin,
  imgReviewTej,
  imgReviewClaire,
  imgReviewSarun,
  imgReviewNjTaylor,
  imgReviewVinKumar,
  imgReviewAudreyOng,
  imgReviewMatiasMuelas,
  imgReviewJooYoung,
} from 'assets';
import styled from '@emotion/styled';
import { BackgroundSection } from '../common';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const ReviewPicture = styled(Picture)`
  max-height: 360px;
`;

const CONTENT = [
  {
    id: 'member-1',
    name: 'Audrey Ong',
    position: 'Director of Partnerships | Secret Signals (Singapore)',
    event: '',
    image: imgReviewAudreyOng,
    quote:
      "The Gig Life Pro team are incredibly well-connected across the globe in every aspect of the music industry and always plan the most thoughtful networking events, panels and workshops. They go out of their way to make sure that everyone in their community is well taken care of at any event and are always up to date on what's going on with everyone, which means that they are constantly able to personally link you up with other industry professionals who can value-add to your current and upcoming projects.",
  },
  {
    id: 'member-2',
    name: 'Vin Kumar',
    position: 'Co-Founder & Director | Megatix Thailand',
    event: 'GLP & Friends Bangkok (Maho Rasop) 2024',
    image: imgReviewVinKumar,
    quote:
      "The GLP & Friends Mixer – Bangkok Edition was a fantastic event that connected us with valuable industry professionals and potential business leads. Giglife Pro’s ability to bring together key players in the live entertainment and events space is truly impressive and unmatched. We’re grateful for the opportunity to be involved and look forward to more collaborations in the future!",
  },
  {
    id: 'member-3',
    name: 'Matias Muelas',
    position: 'Founder / Partner / Booking Agent | Special Blend | Germany',
    event: 'GLP & Friends Seoul Mixer ft. HIPHOPPLAYA Festival 2025',
    image: imgReviewMatiasMuelas,
    quote:
      "Gig Life Pro’s Seoul mixer brought together the real players of the industry. High-level connections, future-shifting conversations, and global moves all in one room. The kind of room you need to be in.",
  },
  {
    id: 'member-4',
    name: 'Jeff Bell',
    position: 'GM, International | Partisan Records',
    event: 'UK',
    image: imgReviewJeff,
    quote:
      "From a big picture perspective down to localised campaign execution, and everything in between, GLP has been an invaluable resource as we've developed key relationships, systems and infrastructure across the region to better serve the global footprint we strive for all of our artists.",
  },
  {
    id: 'member-5',
    name: 'Joo Young',
    position: 'Senggi Studio Korea (Venue Partner)',
    event: 'GLP & Friends Seoul Mixer ft. HIPHOPPLAYA Festival 2025',
    image: imgReviewJooYoung,
    quote:
      "Gig Life Pro is an incredible platform that breaks down barriers in the music industry and fosters genuine connections.  If you want to be at the heart of the global music business, GLP is a must!",
  },
  {
    id: 'member-6',
    name: 'Ayudita Hariadi',
    position: 'Booking Manager | Ismaya Group Indonesia',
    event: '',
    image: imgReviewAyudita,
    quote:
      'I always enjoy Gig Life Pro virtual Happy Hours! Especially during this pandemic time, I have exciting catch up time with the community. Lots of sharing and learning. Community support is one of the things we need to get through this.',
  },
  {
    id: 'member-7',
    name: 'Justin Sweeting',
    position: 'Magnetic Asia',
    event: '',
    image: imgReviewJustin,
    quote:
      'We’ve worked with Gig Life Pro on projects during both Clockenflap and Sonar Hong Kong.  Throughout, we have very much appreciated how well they have complemented as well as added value towards an aligned vision of bringing the industry together in meaningful ways.  They expertly tow that fine line of being able to professionally manage and create environments which are fun, friendly and highly effective in encouraging industry connections both within the region and beyond.',
  },
  {
    id: 'member-8',
    name: 'Tej Brar',
    position: 'Founder & Managing Director | Third Culture Entertainment',
    event: '',
    image: imgReviewTej,
    quote:
      "Gig Life Pro has been an incredible community to be a part of! Whether it's attending various festivals/events across Asia and building my network on-ground or through their virtual happy hours, i've been able to meet a lot of like minded individuals throughout the APAC region. Through one of the virtual happy hours I connected with Def Jam SEA which led to us signing Yung Raja for India, an incredible partnership made possible by GLP!",
  },
];

function SlideArrow(props) {
  // eslint-disable-next-line react/prop-types
  const { currentSlide, icon, onClick, changeIndex, slideCount } = props;
  let slideCycle = currentSlide + changeIndex;
  if (slideCycle < 0) slideCycle = slideCount - 1;
  if (slideCycle === slideCount) slideCycle = 0;

  return (
    <BackgroundSection
      backgroundImage={`url(${CONTENT[slideCycle].image.default})`}
      className="flex bg-cover bg-center lg:mx-16 rounded mb-1 cursor-pointer"
      onClick={() => {
        onClick();
      }}
      role="presentation"
    >
      <div
        className={classnames(
          'flex items-center',
          'rounded lg:px-6',
          'bg-gradient-turqoise-violet opacity-75'
        )}
      >
        <Picture src={icon} className="w-12" />
      </div>
    </BackgroundSection>
  );
}

const SaySlider = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 750,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <SlideArrow icon={iconRightArrow} changeIndex={1} />,
    prevArrow: <SlideArrow icon={iconLeftArrow} changeIndex={-1} />,
    className: 'flex',
  };

  return (
    <div className="hidden sm:block container mx-auto px-6 mt-20">
      <h2 className="text-center mb-20">What Our Members Say</h2>

      <Slider {...settings}>
        {CONTENT.map(({ id, name, position, image, quote, event }) => (
          <div key={id}>
            <div className="grid md:grid-cols-5 items-center">
              <ReviewPicture
                src={image}
                className="p-5 sm:p-8 md:p-0 md:col-span-2"
              />
              <div className="p-4 md:p-8 md:col-span-3">
                <i className="font-light">{quote}</i>
                <div className="text-lg mt-4">{name}</div>
                <div className='mt-2'>{position}</div>
                <div className='mt-2'>{event}</div>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default SaySlider;
